window.CartDrawerController = (function() {
  let cartDrawer = null;

  function init() {
    if (!cartDrawer) cartDrawer = document.querySelector('cart-drawer');
    return !!cartDrawer;
  }

  function updateElementFromHTML(htmlString, selector, targetEl) {
    const source = new DOMParser().parseFromString(htmlString, 'text/html').querySelector(selector);
    if (source) targetEl.innerHTML = source.innerHTML;
  }

  function openCartDrawer() {
    if (!init()) return false;
    cartDrawer.open();
    return true;
  }

  function closeCartDrawer() {
    if (!init()) return false;
    cartDrawer.close();
    return true;
  }

  function updateCartContents() {
    if (!init()) return Promise.reject('Cart drawer not initialized');

    return fetch('/cart?sections=cart-drawer,cart-icon-bubble')
      .then(response => response.json())
      .then(sections => {
        if (!sections || typeof sections !== 'object') {
          throw new Error('Invalid response format from cart sections');
        }

        if (sections['cart-drawer']) {
          cartDrawer.classList.toggle('is-empty', sections['cart-drawer'].includes('is-empty'));
        }

        try {
          cartDrawer.renderContents({ sections });
        } catch (e) {
          if (sections['cart-drawer']) {
            const drawerInner = cartDrawer.querySelector('.drawer__inner');
            if (drawerInner) updateElementFromHTML(sections['cart-drawer'], '.drawer__inner', drawerInner);
          }
          if (sections['cart-icon-bubble']) {
            const iconBubble = document.getElementById('cart-icon-bubble');
            if (iconBubble) updateElementFromHTML(sections['cart-icon-bubble'], '#cart-icon-bubble', iconBubble);
          }
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-controller' });
        }
        return sections;
      })
      .catch(error => {
        console.error('Error updating cart drawer:', error);
        throw error;
      });
  }

  function addItemAndOpenDrawer(variantId, quantity, properties) {
    quantity = Math.max(1, parseInt(quantity) || 1);
    properties = properties || {};
    if (!init()) return Promise.reject('Cart drawer not initialized');
    if (!variantId || isNaN(Number(variantId))) return Promise.reject('Invalid variant ID');

    const data = { items: [{ id: variantId, quantity }] };
    if (Object.keys(properties).length > 0) data.items[0].properties = properties;

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    .then(response => {
      if (!response.ok) return response.json().catch(() => ({})).then(d => { throw new Error(d.description || response.statusText || 'Error adding item'); });
      return response.json();
    })
    .then(() => { openCartDrawer(); updateCartContents(); return true; })
    .catch(error => { console.error('Error adding item to cart:', error); throw error; });
  }

  return {
    open: openCartDrawer,
    close: closeCartDrawer,
    update: updateCartContents,
    addItem: addItemAndOpenDrawer
  };
})();
